import { toIsoDateString } from '@omnea-digital/toolbox'
import { v4 } from 'uuid'
import { PaymentIntervalEnum } from '@omnea-app/packages/universal/hasura/graphql'
import { AgreementTermSpendItemModel, SpendItemFrequency } from '../entities'
import { AgreementInputPricing } from './agreementInput'

type SpendMatchParts = Pick<AgreementTermSpendItemModel, 'description' | 'rate' | 'frequency' | 'startDate' | 'endDate'>

const spendMatchKey = ({ description, rate, frequency, startDate, endDate }: SpendMatchParts): string =>
  JSON.stringify([description, rate, frequency, toIsoDateString(startDate), endDate ? toIsoDateString(endDate) : null])

const queueIdsByMatchKey = (existingSpend: AgreementTermSpendItemModel[]): Map<string, string[]> =>
  existingSpend.reduce((queues, item) => {
    const key = spendMatchKey(item)
    return queues.set(key, [...(queues.get(key) ?? []), item.id])
  }, new Map<string, string[]>())

export const mapPricingToSpendItem = (
  pricing: AgreementInputPricing,
  existingSpend: AgreementTermSpendItemModel[] = []
): AgreementTermSpendItemModel[] => {
  const reusableIds = queueIdsByMatchKey(existingSpend)

  return pricing.priceRows.map((row) => {
    const quantity = row.duration ?? 1
    const totalAmount = row.amount * quantity
    const totalAmountInDefaultCurrency = totalAmount / pricing.currency.fxRate
    const frequency = row.frequency as SpendItemFrequency
    const endDate = frequency === PaymentIntervalEnum.ONE_OFF ? null : row.endDate
    const matchKey = spendMatchKey({
      description: row.name,
      rate: row.amount,
      frequency,
      startDate: row.startDate,
      endDate,
    })

    return {
      id: reusableIds.get(matchKey)?.shift() ?? v4(),
      description: row.name,
      totalAmount,
      frequency,
      startDate: row.startDate,
      endDate,
      quantity,
      rate: row.amount,
      currencyCode: pricing.currency.currencyCode,
      fxRate: pricing.currency.fxRate,
      fxTime: pricing.currency.fxTime,
      totalAmountInDefaultCurrency,
    }
  })
}
